class currencySelector extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.detailsEl = this.querySelector("details");
    this.country_code = this.querySelector("[data-country-code]");
    this.currencyButtons = this.querySelectorAll("[data-value]");
  }

  connectedCallback() {
    this.currencyButtons.forEach((currencyBtn) => {
      currencyBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.country_code.value = currencyBtn.dataset.value;
        this.form.submit();
      });
    });

    document.addEventListener("click", (e) => {
      if (!this.contains(e.target)) {
        this.detailsEl.removeAttribute("open");
      }
    });
  }
}

if (!customElements.get("currency-selector")) {
  customElements.define("currency-selector", currencySelector);
}
